import ChipComponentRequisitionStatus from '@/components/chip/ChipComponentRequisitionStatus';
import type { StatusChipProps } from '@/components/chip/ChipTicketStatus';
import { ComponentRequisitionStatusEnum } from '@/types/enums/component-requisition-status.enum';
import { t } from '@/utils/lang';

export const getComponentRequisitionStatusData = (props: StatusChipProps) => {
    return ChipComponentRequisitionStatus(props);
};

export const getComponentRequisitionOptionsFilter = (
    isFilter?: boolean,
    allowedStatus?: ComponentRequisitionStatusEnum[]
) => {
    let enumValues: any = ComponentRequisitionStatusEnum;
    const options: any[] = [];

    if (allowedStatus) {
        enumValues = Object.keys(enumValues).reduce((obj, key) => {
            if (allowedStatus.includes(enumValues[key])) {
                obj[key] = enumValues[key];
            }

            return obj;
        }, {});
    }

    Object.keys(enumValues).forEach(key => {
        const data = getComponentRequisitionStatusData({
            status: enumValues[key],
            showChip: false,
        });

        options.push({
            id: enumValues[key],
            value: !isFilter ? enumValues[key] : key.toUpperCase(),
            title: data.label,
            label: t(data.label, 'ComponentRequisition'),
        });
    });

    return options;
};
